module.exports = __webpack_public_path__ + "img/ar.564bde1a.svg";